module.exports = __webpack_public_path__ + "static/media/dSlider4.6bbd5366.png";